import { custom, object } from 'zod';

import { isDateTimeValid, isFuture, mergeDateAndTime } from '@occc-app/lib/date';
import {
  IS_DATE_VALID,
  IS_REQUIRED,
  IS_TIME_VALID,
} from '@occc-app/lib/constants/validationMessages';

import { isFutureDateWithoutTime } from './schedule-date.utils';
import { IS_FUTURE_DATE_MESSAGE, IS_FUTURE_TIME_MESSAGE } from './schedule-date.constants';
import { MessagingCampaignScheduleFormInitialValues } from './schedule-form.types';

export const DateSchema = custom<Date>(isDateTimeValid, IS_DATE_VALID);
export const TimeSchema = custom<Date>(isDateTimeValid, IS_TIME_VALID);

export const ScheduleFormSchema = object({
  publishAtDate: DateSchema.refine(isFutureDateWithoutTime, {
    message: IS_FUTURE_DATE_MESSAGE,
  }).refine((date) => !!date, { message: IS_REQUIRED }),
  publishAtTime: TimeSchema.refine((time) => !!time, { message: IS_REQUIRED }),
}).refine(
  (data) => {
    if (!data.publishAtDate || !data.publishAtTime) return true;
    const combined = mergeDateAndTime(data.publishAtDate, data.publishAtTime);
    return isFuture(combined);
  },
  { message: IS_FUTURE_TIME_MESSAGE, path: ['publishAtTime'] },
);

export const validateScheduleSync = (values: MessagingCampaignScheduleFormInitialValues) =>
  ScheduleFormSchema.safeParse(values);
